import styled from 'styled-components';
import { PEARL_VENDOR_SIGNUP_LOADER_COLOR } from 'shared/utils/pearlVendorSignupFlow';

const track = 'rgba(42, 132, 120, 0.22)';

const PearlConnectSpinnerRing = styled.div`
    box-sizing: border-box;
    width: 48px;
    height: 48px;
    border: 4px solid ${track};
    border-top-color: ${PEARL_VENDOR_SIGNUP_LOADER_COLOR};
    border-radius: 50%;
    animation: pearlConnectSpinnerRotate 0.75s linear infinite;

    @keyframes pearlConnectSpinnerRotate {
        to {
            transform: rotate(360deg);
        }
    }
`;

export { PearlConnectSpinnerRing };
